import React from "react";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { HiChevronDown } from "react-icons/hi";

const TemplateView = ({
  data,
  showAgentProTipDraft = false,
  // Vendor templates only — buyer templates have no such field on their schema.
  showWhenItGoesOut = false,
  showNetwork = false,
}) => {
  const formatArray = (array) => {
    if (!array || array.length === 0) return "None";
    return array.join(", ");
  };

  // Format tags to show their names
  const formatTags = (tags) => {
    if (!tags || tags.length === 0) return "None";
    
    // If tags are objects with name property, extract and join names
    if (typeof tags[0] === 'object' && tags[0].name) {
      return tags.map(tag => tag.name).join(", ");
    }
    
    // Otherwise just join the array
    return tags.join(", ");
  };

  return (
    <div className="space-y-4 p-2">
      <div className="space-y-2">
        <h4>Name</h4>
        <p>{data?.name || "Not specified"}</p>
      </div>

      <div className="space-y-2">
        <h4>Description</h4>
        <p><pre>{data?.description || "Not specified"}</pre></p>
      </div>

      <div className="space-y-2">
        <h4>Purpose</h4>
        <p><pre>{data?.purpose || "Not specified"}</pre></p>
      </div>

      {showWhenItGoesOut && (
        <div className="space-y-2">
          <h4>When it goes out</h4>
          <pre className="whitespace-pre-wrap">
            {data?.whenItGoesOut || "Not specified"}
          </pre>
        </div>
      )}

      <div className="space-y-2">
        <h4>Special Instructions</h4>
        <p><pre>{data?.specialInstructions || "Not specified"}</pre></p>
      </div>

      <div className="space-y-2">
        <h4>Prompt</h4>
        <p><pre>{data?.prompt || "Not specified"}</pre></p>
      </div>

      {showAgentProTipDraft && (
        <div className="space-y-2">
          <h4>Agent Pro Tip</h4>
          <p><pre>{data?.agentProTipDraft || "Not specified"}</pre></p>
        </div>
      )}
      
      <div className="space-y-2">
        <h4>Tags</h4>
        <p>{formatTags(data?.tags)}</p>
      </div>

      <div className="space-y-2">
        <h4>Approval</h4>
        <p>{data?.approval ? "Yes" : "No"}</p>
      </div>

      <div className="space-y-2">
        <h4>Sender</h4>
        <p>{data?.sender || "Not specified"}</p>
      </div>

      <div className="space-y-2">
        <h4>Sale Process</h4>
        <p>{formatArray(data?.saleProcess)}</p>
      </div>

      {showNetwork && (
        <div className="space-y-2">
          <h4>Network</h4>
          <p>{data?.networkId?.name || "All networks"}</p>
        </div>
      )}

      {/* Objections Section */}
      <div className="space-y-2">
        <h4>Objections {data?.objections?.length > 0 && `(${data.objections.length})`}</h4>
        
        {data?.objections && data.objections.length > 0 ? (
          <div className="space-y-2">
            {data.objections.map((objection, index) => (
              <Disclosure
                key={index}
                as="div"
                className="w-full"
                defaultOpen={false}
              >
                <DisclosureButton className="p-3 group flex w-full items-center justify-between rounded-md bg-lightgray">
                  <span className="font-medium truncate flex-1 text-left">
                    {index + 1}: {objection.objection || "Empty objection"}
                  </span>
                  <HiChevronDown className="group-data-[open]:rotate-180" />
                </DisclosureButton>
                <DisclosurePanel className="mt-2 p-4 bg-white border border-mediumgray rounded space-y-3">
                  <div className="space-y-2">
                    <label className="form-label text-sm font-semibold">Objection</label>
                    <p className="text-sm">{objection.objection || "Not specified"}</p>
                  </div>

                  <div className="space-y-2">
                    <label className="form-label text-sm font-semibold">Preempt</label>
                    <p className="text-sm"><pre className="whitespace-pre-wrap">{objection.preempt || "Not specified"}</pre></p>
                  </div>

                  <div className="space-y-2">
                    <label className="form-label text-sm font-semibold">How It Lands</label>
                    <p className="text-sm"><pre className="whitespace-pre-wrap">{objection.howItLands || "Not specified"}</pre></p>
                  </div>
                </DisclosurePanel>
              </Disclosure>
            ))}
          </div>
        ) : (
          <p className="text-darkgray text-sm italic">No objections added</p>
        )}
      </div>
    </div>
  );
};

export default TemplateView;
